import React, { FunctionComponent, useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { Flex, Text, Box } from 'rebass/styled-components';
import HorizontalRule from './HorizontalRule';
import { ReactComponent as SelectCaretComponent } from '../assets/select-caret.svg';

const CARD_COUNT = 5;
const INSIDE_CARD_COUNT = 5;

interface IStyledIcon {
  isOpen?: boolean,
  color?: string,
}

const Table = styled.table`
  border-radius: 10px;
  background-color: ${(props) => props.color};
  padding: 16px;
  margin-top: 24px;
  width: 98%;
`;
const TableBody = styled.tbody``;

const TableRow = styled.tr`
  width: 100%
`;
const TableCell = styled.td``;

const StyledIcon = styled.div<IStyledIcon>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  transform: rotate(${(props) => (props.isOpen ? '0' : '-90deg')});
  color: ${(props) => props.color};
`;

const SkeletonLogs: FunctionComponent<any> = ():any => {
  const themeContext = useContext(ThemeContext);
  const color = themeContext.mode === 'light' ? 'rgba(0, 0, 0, 0.15)' : 'rgba(255, 255, 255, 0.15)';
  const highlightColor = themeContext.mode === 'light' ? 'rgba(0, 0, 0, 0.08)' : 'rgba(255, 255, 255, 0.08)';

  return (
    <Box data-testid="loading-skeleton">
      <SkeletonTheme color={color} highlightColor={highlightColor}>
        <Table color={highlightColor}>
          <TableBody>
            <TableRow>
              <TableCell>
                <Flex p={3}>
                  <Flex justifyContent="flex-start" flex={1} ml={2}>
                    <StyledIcon isOpen color={color}>
                      <SelectCaretComponent />
                    </StyledIcon>
                    <Text variant="p2" mr={2}>Conversation ID:</Text>
                    <Skeleton width={155} height={17} style={{ borderRadius: '16px' }} />
                  </Flex>
                  <Flex justifyContent="flex-end" flex={1} mr={2}>
                    <Skeleton width={155} height={20} style={{ borderRadius: '16px' }} />
                  </Flex>
                </Flex>
                <HorizontalRule />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell width="100%">
                <Flex p={3}>
                  <Flex justifyContent="flex-start" flex={1} ml={2}>
                    <Text variant="p2" mr={2}>RESULTS</Text>
                  </Flex>
                  <Flex justifyContent="flex-start" flex={1} mr={2}>
                    <Text variant="p2" mr={2}>NAME</Text>
                  </Flex>
                  <Flex justifyContent="flex-start" flex={2} ml={2}>
                    <Text variant="p2" mr={2}>CONDITION</Text>
                  </Flex>
                  <Flex justifyContent="flex-start" flex={1} mr={2}>
                    <Text variant="p2" mr={2}>ACTIONS</Text>
                  </Flex>
                </Flex>
              </TableCell>
            </TableRow>
            {Array(INSIDE_CARD_COUNT)
              .fill(null)
              .map((item, index) => (
                <TableRow key={index}>
                  <TableCell width="100%">
                    <Flex p={3}>
                      <Flex justifyContent="flex-start" flex={1} ml={2}>
                        <Skeleton width={55} height={20} style={{ borderRadius: '16px' }} />
                      </Flex>
                      <Flex justifyContent="flex-start" flex={1} mr={2}>
                        <Skeleton width={55} height={20} style={{ borderRadius: '16px' }} />
                      </Flex>
                      <Flex justifyContent="flex-start" flex={2} ml={2}>
                        <Skeleton width={55} height={20} style={{ borderRadius: '16px' }} />
                      </Flex>
                      <Flex justifyContent="flex-start" flex={1} mr={2}>
                        <Skeleton width={55} height={20} style={{ borderRadius: '16px' }} />
                      </Flex>
                    </Flex>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>

        {Array(CARD_COUNT)
          .fill(null)
          .map((_, idx) => (
            <Table color={highlightColor} key={idx}>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Flex p={3}>
                      <Flex justifyContent="flex-start" flex={1} ml={2}>
                        <StyledIcon color={color}>
                          <SelectCaretComponent />
                        </StyledIcon>
                        <Text variant="p2" mr={2}>Conversation ID:</Text>
                        <Skeleton width={155} height={17} style={{ borderRadius: '16px' }} />
                      </Flex>
                      <Flex justifyContent="flex-end" flex={1} mr={2}>
                        <Skeleton width={155} height={20} style={{ borderRadius: '16px' }} />
                      </Flex>
                    </Flex>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          ))}
      </SkeletonTheme>
    </Box>
  );
};

export default SkeletonLogs;
